import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class CounterPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateMaterial(inspectionId: string, pointId: string, pluginId: string, value: string): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, value).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, value: string): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, value, 'Value').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
